import Header from "./Compartido/Header";
import HeroSection from "./Ofertas/HeroSection";
import CountdownOffer from "./Ofertas/CountdownOffer";
import OffersGrid from "./Ofertas/OffersGrid";
import RewardsBanner from "./Ofertas/RewardsBanner";
import HotelsCarousel from "./Ofertas/HotelsCarousel";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

const Ofertas = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <HeroSection />
                <div className="container">
                    <CountdownOffer />
                    <OffersGrid />
                    <RewardsBanner />
                </div>
                <HotelsCarousel />
            </main>
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default Ofertas
